import { useEffect, useState } from 'react'
import { TInstrumentsProps } from './Instruments.types'

export const useInstrumentsLogic = (props: TInstrumentsProps) => {
  const { selectedInstruments, onChange } = props
  const [selectedOptions, setSelectedOptions] = useState<string[]>([])

  const handleCheckboxChange = (option: string) => {
    const updatedOptions = selectedOptions.includes(option)
      ? selectedOptions.filter((selectedOption) => selectedOption !== option)
      : [...selectedOptions, option]
    setSelectedOptions(updatedOptions)
    onChange(updatedOptions)
  }

  useEffect(() => {
    setSelectedOptions(selectedInstruments || [])
  }, [selectedInstruments])

  return {
    selectedOptions,
    handleCheckboxChange,
  }
}
